<template>
  <div>
    <div class="content-header">
      <div class="left"></div>
      <div class="right">
        <Dropdown :disabled="!data.id">
          <Button type="primary" :disabled="!data.id">
            商品明细
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list" v-if="data.id">
            <DropdownItem>
              <router-link :to="`/goods/edit/detail/${data.id}`">商品详情</router-link>
            </DropdownItem>
            <DropdownItem>
              <router-link :to="`/goods/edit/attr/${data.id}`">商品规格</router-link>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div>
      <Form ref="form" :model="data" :rules="rule" inline :label-width="90">
        <FormItem prop="main_img" label="商品主图:">
          <div style="line-height: 1;cursor: pointer;width:161px">
            <img width="100" :src="data.main_img?data.main_img:defaultImage" @click="handleVisible = true"/>
          </div>
        </FormItem>
        <!-- <Button size="small">123</Button> -->
        <FormItem prop="main_img" label="商品视频:" v-if="data.id">
          <div v-if="data.show_video">
            <Tag>test.mp4</Tag> <a>预览</a>
          </div>
          <div v-if="!data.show_video">
            <div class="t-center" style="margin-bottom: 5px">
              <label class="ivu-btn ivu-btn-small ivu-btn-primary" for="uploads" style="line-height: 23px;">
                <span>上传视频</span>
              </label>
              <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                      accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadVideo($event)">
            </div>
          </div>
        </FormItem>
        <br/>
        <FormItem prop="name" label="商品名称:">
          <Input type="text" v-model="data.name" placeholder="商品名称"/>
        </FormItem>
        <FormItem prop="show_money" label="商品价格:">
          <InputNumber :min="0" :active-change="false" :precision="2" v-model="data.show_money" style="width: 161px;"></InputNumber>
        </FormItem>
        <FormItem prop="shop_sorts" label="排序值:">
          <InputNumber :min="0" :max="1000" :active-change="false" :precision="0" v-model="data.shop_sorts" style="width: 161px;"></InputNumber>
        </FormItem>
        <br/>
        <FormItem prop="category_id1" label="一级分类:">
          <Select v-model="data.category_id1" style="width:161px">
            <Option v-for="(item,index) in category.item1" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="category_id2" label="二级分类:">
          <Select v-model="data.category_id2" style="width:161px" :disabled="!data.category_id1">
            <Option v-for="(item,index) in category.item2" :key="index" :value="item.id" v-if="item.parent_id === data.category_id1">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="category_id3" label="三级分类:">
          <Select v-model="data.category_id3" style="width:161px" :disabled="!data.category_id2">
            <Option v-for="(item,index) in category.item3" :key="index" :value="item.id" v-if="item.parent_id === data.category_id2">{{item.name}}</Option>
          </Select>
        </FormItem>
        <br/>
        <FormItem prop="stock" label="虚拟销量:">
          <InputNumber :min="0" :active-change="false" :precision="0" v-model="data.stock" style="width: 161px;"></InputNumber>
        </FormItem>
        <FormItem prop="sales" label="虚拟库存:">
          <InputNumber :min="0" :active-change="false" :precision="0" v-model="data.sales" style="width: 161px;"></InputNumber>
        </FormItem>
        <FormItem prop="unit" label="商品单位:">
          <Select v-model="data.unit" filterable allow-create @on-create="createUnit" style="width: 161px;">
            <Option v-for="(item,index) in unit" :value="item" :key="index">{{ item }}</Option>
          </Select>
        </FormItem>
        <br/>
        <FormItem prop="freight_city" label="同城运费:">
          <InputNumber :min="0" :active-change="false" :precision="2" v-model="data.freight_city" style="width: 161px;"></InputNumber>
        </FormItem>
        <FormItem prop="freight_normal" label="常规运费:">
          <InputNumber :min="0" :active-change="false" :precision="2" v-model="data.freight_normal" style="width: 161px;"></InputNumber>
        </FormItem>
        <FormItem prop="freight_far" label="偏远运费:">
          <InputNumber :min="0" :active-change="false" :precision="2" v-model="data.freight_far" style="width: 161px;"></InputNumber>
        </FormItem>
        <br/>
        <FormItem>
          <Button @click="mainSave" type="success">保存</Button>
        </FormItem>
      </Form>
    </div>
    <image-handle v-model="handleVisible" @getUrl="getUrl" title="图片处理"/>
  </div>
</template>

<script>
  import {mapActions} from "vuex"
  import defaultImage from "@/assets/images/default.png"
  import imageHandle from "../../../components/image-handle";
  export default {
    components: {
      imageHandle,
    },
    data() {
      return {
        data: {
          stock: 0,
          sales: 0,
          main_img: null,
          name: "",
          category_id1: null,
          category_id2: null,
          category_id3: null,
          show_money: null,
          freight_city: null,
          freight_normal: null,
          freight_far: null,
          shop_sorts: 0,
        },
        category: {
          item1: [],
          item2: [],
          item3: []
        },
        rule: {
          main_img: [{type: "string",required: true, message: '未上传商品主图', trigger: 'change'}],
          category_id1: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          category_id2: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          category_id3: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          name: [{type: "string",required: true, message: '此项必填', trigger: 'change'}],
          show_money: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          stock: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          sales: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          freight_city: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          freight_normal: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          freight_far: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
          shop_sorts: [{type: "number",required: true, message: '此项必填', trigger: 'change'}],
        },
        defaultImage: defaultImage,

        handleVisible: false,
        unit: [],
      }
    },
    mounted(){
      if(this.$route.params.id){
        this.formatGoods();
      }
      this.formatCategory();
      this.$refs.form.resetFields()
      this.GetUnit().then(res=>{
        this.unit = res;
      })
    },
    methods: {
      // setPicked(){
      //   this.data.shop_picked = this.data.shop_picked?0:1
      // },
      formatCategory(){
        this.GetCategory({status: 0}).then(res=>{
          res.map(item=>{
            this.category[`item${item.level}`].push(item);
          })
        })
      },
      formatGoods(){
        this.GetGoodsMain({id: this.$route.params.id}).then(res=>{
          this.data = res;
        })
      },
      mainSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.SaveGoodsMain(this.data).then(res=>{
              this.data.id = res;
              this.$Message.success("保存成功");
              this.$router.back(-1);
            })
          }
        })
      },
      getUrl(url){
        this.data.main_img = url;
      },
      createUnit(name){
        if(name.length > 5){
          this.$Message.error("单位长度不得超过5位")
          return
        }
        this.SetUnit({name: name}).then(res=>{
          this.unit.push(name)
          this.data.unit = name
        })
      },
      ...mapActions(["GetCategory","GetGoodsMain","SaveGoodsMain","GetUnit","SetUnit"])
    },
  }
</script>

<style lang="less" scoped>

</style>
